import { FC, memo } from 'react';

import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { PlayerTypesInFlow, SelectPlayerContentViewMode } from '../types';
import { TPlayerTypeItem } from './types';
import PlayerTypeItem from './PlayerTypeItem';

import styles from './SelectPlayerModal.module.scss';

interface PlayerTypeItemListProps {
  contentViewMode: SelectPlayerContentViewMode;
  playersData: TPlayerTypeItem[];
  videoPlayersData: TPlayerTypeItem[];
  selectedPlayerInFlow: PlayerTypesInFlow;
  onPlayerChange: (playerType: PlayerTypesInFlow) => void;
}

export const PlayerTypeItemList: FC<PlayerTypeItemListProps> = memo(
  ({ contentViewMode, playersData, videoPlayersData, selectedPlayerInFlow, onPlayerChange }) => {
    const { isDesktopL } = useMedia();

    if (contentViewMode === SelectPlayerContentViewMode.VIDEO_STREAM) {
      return (
        <div className={styles.playerItemsContainerShort}>
          {videoPlayersData.map((player) => (
            <PlayerTypeItem
              player={player}
              selectedPlayer={selectedPlayerInFlow}
              onPlayerChange={onPlayerChange}
              key={player.type}
              withVideoDevice
            />
          ))}
        </div>
      );
    }

    if (playersData.length === 5) {
      if (isDesktopL) {
        return (
          <div className={styles.containerWithoutOne}>
            <div className={styles.topRow}>
              {playersData.slice(0, 2).map((player) => (
                <PlayerTypeItem
                  key={player.type}
                  player={player}
                  selectedPlayer={selectedPlayerInFlow}
                  onPlayerChange={onPlayerChange}
                />
              ))}
            </div>
            <div className={styles.bottomRow}>
              {playersData.slice(2).map((player) => (
                <PlayerTypeItem
                  key={player.type}
                  player={player}
                  selectedPlayer={selectedPlayerInFlow}
                  onPlayerChange={onPlayerChange}
                />
              ))}
            </div>
          </div>
        );
      }

      return (
        <div className={styles.playerItemsContainerForFallback}>
          {playersData.map((player) => (
            <PlayerTypeItem
              key={player.type}
              player={player}
              selectedPlayer={selectedPlayerInFlow}
              onPlayerChange={onPlayerChange}
            />
          ))}
        </div>
      );
    }

    return (
      <div className={styles.playerItemsContainer}>
        {playersData.map((player) => (
          <PlayerTypeItem
            player={player}
            selectedPlayer={selectedPlayerInFlow}
            onPlayerChange={onPlayerChange}
            key={player.type}
          />
        ))}
      </div>
    );
  }
);
